import { createFileRoute } from "@tanstack/react-router";
import CurrentPatients from "@/pages/CurrentPatients";
export const Route = createFileRoute("/current-patients")({
  component: RouteComponent,
  head() {
    return {
      meta: [
        {
          title: "Current Patients | Neuro Wellness TMS",
        },
        {
          name: "description",
          content:
            "Resources for current Neuro Wellness TMS patients in Coral Springs, FL. Request a benefits check, schedule a visit, or start a new treatment course.",
        },
        {
          property: "og:title",
          content: "Current Patients | Neuro Wellness TMS",
        },
        {
          property: "og:description",
          content:
            "Resources for current Neuro Wellness TMS patients in Coral Springs, FL. Request a benefits check, schedule a visit, or start a new treatment course.",
        },
        {
          property: "og:url",
          content: "https://neurowellnesstms.com/current-patients",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/current-patients",
        },
      ],
    };
  },
});
function RouteComponent() {
  return <CurrentPatients />;
}
